import React, { useState } from 'react';
import type { EpicSession } from '../../../../../../shared/types/epics';
import { SessionRow, TH } from '../../../../components/epicDetail/AgentRunRow';
import { Card, CardHeader, CardBody } from '../../../../components/ui';

// FORGE-3xx: setup / one-off runs (planner, graph-builder, plan-qa) — not tied
// to a story or a PR. Collapsed by default: it's audit detail, not day-to-day
// signal. UX-05: retitled "Setup runs" as the sole always-visible label (the
// eyebrow used to say SETUP RUNS while the heading spelled out the agent
// types; the tab now supplies that context, so the heading is just the name).
export const OrphanSessionsCard: React.FC<{
  sessions: EpicSession[];
  onOpenTranscript: (storyId: string, agentType: string, taskArn?: string | null) => void;
}> = ({ sessions, onOpenTranscript }) => {
  const [expanded, setExpanded] = useState(false);
  // Group by their storyId so the table stays readable.
  const grouped = new Map<string, EpicSession[]>();
  for (const s of sessions) {
    const list = grouped.get(s.storyId) ?? [];
    list.push(s);
    grouped.set(s.storyId, list);
  }
  return (
    <Card>
      <CardHeader>
        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          className="flex items-center gap-2 text-left"
          aria-expanded={expanded}
        >
          <span className={`text-slate-400 transition-transform ${expanded ? 'rotate-90' : ''}`}>▸</span>
          <div>
            <span className="font-mono text-xs text-slate-500">SETUP RUNS</span>
            <h3 className="text-base font-semibold text-slate-900 mt-0.5">
              Setup runs
            </h3>
          </div>
        </button>
        <span className="text-xs text-slate-500">{sessions.length} runs</span>
      </CardHeader>
      {expanded && (
      <CardBody className="p-0">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b border-slate-200">
              <tr>
                <th className={TH}>Agent</th>
                <th className={TH}>Status</th>
                <th className={TH}>Started</th>
                <th className={TH}>Duration</th>
                <th className={TH}>Model</th>
                <th className={TH}>Cost</th>
                <th className={TH}>Iters</th>
                <th className={TH} />
              </tr>
            </thead>
            <tbody>
              {[...grouped.entries()].map(([sid, list]) => (
                <React.Fragment key={sid}>
                  <tr className="border-t border-slate-100">
                    <td colSpan={8} className="px-4 py-1.5 text-xs font-mono text-slate-400 bg-slate-50/70">
                      {sid}
                    </td>
                  </tr>
                  {list.map((s) => (
                    <SessionRow
                      key={s.sessionId}
                      session={s}
                      onOpenTranscript={(agent, taskArn) => onOpenTranscript(sid, agent, taskArn)}
                    />
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </CardBody>
      )}
    </Card>
  );
};
